<template>
  <v-form ref="form" class="mt-3 mx-3">

    <BaseUtil ref="util" :pageLoading="pageLoading" />

    <v-row>

      <v-col cols="12">
        <v-text-field v-model="entry.description" v-bind="getObject('description')" label="Descrição" autocomplete="off"
          :disabled="readOnly" />
      </v-col>

      <v-col cols="12">
        <MultiSelect v-model="entry.tablePriceIdsAttribute" v-bind="getObject('tablePriceIdsAttribute')"
          label="Tabela de preços" :items="tablePricesList" :loadingItems="listLoading" :maxLimit="null"
          itemSubText="additionalInfo" :readOnly="readOnly">
        </MultiSelect>
      </v-col>

      <v-col cols="12">
        <MultiSelect v-model="entry.paymentConditionRuleIdsAttribute"
          v-bind="getObject('paymentConditionRuleIdsAttribute')" label="Condições de pagamento"
          :items="paymentConditionRulesList" :loadingItems="listLoading" :maxLimit="null" itemSubText="additionalInfo"
          :readOnly="readOnly">
        </MultiSelect>
      </v-col>

      <v-col cols="12">
        <MultiSelect v-model="entry.itemIdsAttribute" v-bind="getObject('itemIdsAttribute')" label="Insumos"
          :items="itemsList" :loadingItems="listLoading" :maxLimit="null" itemSubText="additionalInfo"
          :readOnly="readOnly">
        </MultiSelect>
      </v-col>

      <v-col cols="12" sm="12" md="4" v-if="entry.percentType == 0">
        <MaskedTextField v-bind="getObject('percent')" :inputData.sync="entry.percent" mask-type="13v2"
          label="Percentual de acréscimo" autocomplete="off" :disabled="readOnly" />
      </v-col>

      <v-col cols="12" sm="12" md="4" v-if="entry.percentType == 1">
        <MaskedTextField v-bind="getObject('percent')" :inputData.sync="entry.percent" mask-type="13v2"
          label="Percentual de desconto" autocomplete="off" :disabled="readOnly" />
      </v-col>

      <!-- <v-col cols="12" sm="12" md="3">
        <MaskedTextField v-bind="getObject('commission')" :inputData.sync="entry.commission" mask-type="13v2"
          label="Percentual de comissão" autocomplete="off" :disabled="readOnly" />
      </v-col> -->

      <v-col cols="12" sm="12" md="4">
        <v-autocomplete v-model="entry.percentType" v-bind="getObject('percentType')" label="Tipo"
          :items="extraData.accountContext.percentTypes" item-value="id" item-text="name" autocomplete="off"
          :disabled="readOnly">
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="4" v-if="entry.percentType == 0">
        <MaskedTextField v-bind="getObject('discountAddition')" :inputData.sync="entry.discountAddition"
          mask-type="13v2" label="Desconto" autocomplete="off" :disabled="readOnly" />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
// import CultureNew from "@models/cultures/new.vue"
import BaseUtil from "@shared_components/base_util.vue"
import BrandNew from "@models/brands/new.vue"
// import NewItemSelect from " /new_item_select.vue"
import MultiSelect from "@shared_components/multi_select.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      purchaseItemsList: [],
      purchaseItemsListLoading: false,

      tablePricesList: [],
      listLoading: false,

      paymentConditionRulesList: [],

      itemsList: [],

      itemsSearch: "",
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    // CultureNew: CultureNew,   
    BaseUtil: BaseUtil,
    BrandNew: BrandNew,
    MultiSelect: MultiSelect,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    this.getData();
  },
  mounted() {
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
  },
  watch: {
    itemsSearch: function (newSearch, oldSearch) {
      // console.log(newSearch, newSearch, oldSearch, oldSearch)
      if (this.itemsSearch && this.itemsSearch.length > 0) {
        if ((!this.entry.item || this.entry.item.name != this.itemsSearch) && newSearch.length >= 3) {
          if (this.timer) {
            clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
            // console.log(newSearch, newSearch);
            this.getPurchaseItems();
          }, 1000);
        }
      }
    },
  },
  methods: {
    getObject: function (element, component) {
      return this.entryAttributes[element];
    },
    brandCreated: function (brand) {
      if (brand.brandType == "item") {
        this.extraData.accountGlobalSharedContext.allBrandsOfItems.unshift(brand);
        this.entry.brandId = brand.id;
        this.entry.brand = brand;
      } else {
        this.$refs.util.showErrorMessage("A Marca cadastrada não é do tipo Item, por isso não irá aparecer na lista de marcas!");
      }
    },
    getData: function () {
      this.listLoading = true;
      this.$apollo
        .query({
          query: LOAD_DATA_QUERY,
          variables: {
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.tablePricesList = response.data.accountContext.allTablePrices;
          this.paymentConditionRulesList = response.data.accountContext.allPaymentConditionRules;
          this.itemsList = response.data.accountContext.allItems;
          // console.log("itemlist", this.itemsList);
        })
        .catch(response => console.log(response))
        .finally(() => (this.listLoading = false));
    },
    isFormValid: function () {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function () {
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function () {
      this.$refs.form.resetValidation();
    },
  }
};

const LOAD_DATA_QUERY = gql`
  query{
    accountContext {
      allPaymentConditionRules {
        id
        name
      }
      allTablePrices{
        id
        name
      }
      allItems{
        id
        name
        additionalInfo
      }
    }
  }
`;
</script>

<style scoped></style>
